$(document).ready(function (){
    var card_el = $('#openbucks-card');
    card_el.on('keyup', function(){
        var input = this.value;
        input = input.replace(/\D/g,'');
        this.value = input.match(/(\d{1,4})/g).join(" ");
    });
});